/*
 * Scenario: sketch-empty-section
 *
 * Phase-3: Demonstriert write_sketch — der Agent legt eine Notes-Hierarchie
 * als neue aktive Absaetze in der aktuellen Section an. Auto-Apply ohne
 * Review. Cmd+Z rollt die ganze Skizze in einem Schritt zurueck.
 */

import { emit, resolve } from './_helpers.js'

export const name = 'sketch-empty-section'
export const description = 'Sketch a 5-item outline into the current section (auto-apply).'

export async function run(state) {
    const toolCallId = 'tu_sketch_' + Date.now().toString(36)

    await emit(state, 'session', { sessionId: 'mock-sketch' }, 0)
    await emit(state, 'thinking', {
        text: 'Let me sketch a structure for this scene…'
    }, 250)
    await emit(state, 'thinkingDone', {}, 150)
    await emit(state, 'toolCall', {
        toolCallId,
        tool: 'write_sketch',
        input: { items: 5 }
    }, 100)

    const separatorId = resolve(state, '$cursor.separatorId')

    await emit(state, 'proposeSketch', {
        toolCallId,
        separatorId,
        area: 'main',
        afterParagraphId: null,  // ans Section-Ende anhaengen
        items: [
            { outlineDepth: 0, note: 'Anna enters the room' },
            { outlineDepth: 1, note: 'Inner monologue: the letter' },
            { outlineDepth: 0, note: 'Karl arrives' },
            { outlineDepth: 1, note: 'They argue about the past' },
            { outlineDepth: 0, note: 'Storm breaks out' }
        ],
        reason: 'A 5-step skeleton from coarse to fine.'
    }, 400)

    await emit(state, 'toolResult', {
        toolCallId, tool: 'write_sketch', summary: 'applied 5 sketch items'
    }, 100)

    await emit(state, 'delta', {
        text: 'I sketched the scene directly into your outline (5 points). Cmd+Z rolls it back if needed.'
    }, 300)
    await emit(state, 'done', { usage: {} }, 100)
}
